import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Wishlist = {
  wishlist_id?: number; // 찜/위시리스트 idx
  user_id?: number; // 유저 idx
  shop_information_id?: number; // 쇼/브/매/지 idx
  product_id?: number; // 상품 idx
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Wishlist
   * --
   */
  getWishlists: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_WISHLIST, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Wishlist
   * --
   */
  getWishlist: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_WISHLIST, {
        wishlist_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Wishlist
   * --
   */
  createWishlist: async (body: Wishlist) => {
    try {
      const res = await $http.post(APIConstant.CREATE_WISHLIST, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Wishlist
   * --
   */
  updateWishlist: async (body: Wishlist) => {
    try {
      const { wishlist_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_WISHLIST, {
        wishlist_id: wishlist_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Wishlist
   * --
   */
  deleteWishlist: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_WISHLIST, {
        wishlist_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
